<template>
  <v-autocomplete
    v-model="value"
    :items="items"
    item-text="key"
    item-value="key"
    :label="label"
    :clearable="clearable"
    return-object
    hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";

export default {
  name: "r-currency-kind-dropdown",

  props: {
    model: VueTypes.instanceOf(CurrencyKindModel),
    label: VueTypes.string.def("Currency Kind"),
    clearable: VueTypes.bool.def(false),
    modifier: VueTypes.bool.def(false),
    mapEnergy: VueTypes.bool.def(false)
  },

  computed: {
    value: {
      get() {
        return this.model;
      },
      set(v) {
        const isObj = v && typeof v === 'object';
        const key = isObj ? v.key : null;

        if (this.modifier || this.mapEnergy) {
          this.$emit("update:model", key);
        } else {
          this.$emit("update:model", v);
        }
      }
    },

    items() {
      if (this.modifier) {
        return RedactorUtils.getModifierCurrencyKinds();
      }

      if (this.mapEnergy) {
        return RedactorUtils.getMapEnergyCurrencyKinds();
      }

      const mapKind = RedactorUtils.getCurrentMapKind?.();
      const mapId = mapKind?.code ?? null;

      const allItems = RedactorUtils.getCurrencyKinds?.() || [];

      return (mapId && mapId !== 9999)
        ? allItems.filter(item => item?.maps?.includes(mapId))
        : allItems;
    }
  }
};
</script>
